// Geteilte Europe/Berlin-Zeit-Helfer für Begrüßungen (Privat-Chat + Markt-Hero).
// Vorher lokal in pages/privat.tsx — extrahiert für Wiederverwendung im Hero.

/** YYYY-MM-DD-String für das Europe/Berlin-Lokaldatum. */
export function berlinDateKey(d: Date): string {
  return d.toLocaleDateString('en-CA', { timeZone: 'Europe/Berlin' });
}

/** Wochenende (Sa/So) in Berlin? */
export function isBerlinWeekend(d: Date): boolean {
  const wd = d.toLocaleDateString('en-US', { timeZone: 'Europe/Berlin', weekday: 'long' });
  return wd === 'Saturday' || wd === 'Sunday';
}

/** Stunde (0–23) in Berlin. */
export function berlinHour(d: Date): number {
  const s = d.toLocaleString('de-DE', {
    timeZone: 'Europe/Berlin',
    hour: '2-digit',
    hour12: false,
  });
  return parseInt(s, 10) || 0;
}

/** „14:35" in Berlin-Zeit. */
export function formatBerlinTime(d: Date): string {
  return d.toLocaleTimeString('de-DE', {
    timeZone: 'Europe/Berlin',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** „Mittwoch, 01.07." in Berlin-Zeit. */
export function formatBerlinWeekdayDate(d: Date): string {
  return d.toLocaleDateString('de-DE', {
    timeZone: 'Europe/Berlin',
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
  });
}

/** „heute" / „gestern" / „am 28.06." — relativ zu `now` (Default: jetzt). */
export function formatBerlinRelative(d: Date, now: Date = new Date()): string {
  const today = berlinDateKey(now);
  const prev = berlinDateKey(d);
  if (today === prev) return 'heute';
  const yesterday = new Date(now.getTime() - 86_400_000);
  if (berlinDateKey(yesterday) === prev) return 'gestern';
  return `am ${d.toLocaleDateString('de-DE', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit' })}`;
}

/** Menschliche Lücken-Dauer aus Stunden: „40 Minuten" / „gut 5 Stunden" / „etwa einen Tag" / „3 Tage". */
export function formatGap(hours: number | null): string {
  if (hours === null) return '';
  if (hours < 1) return `${Math.round(hours * 60)} Minuten`;
  if (hours < 12) return `gut ${Math.round(hours)} Stunden`;
  if (hours < 36) return `etwa einen Tag`;
  return `${Math.round(hours / 24)} Tage`;
}
